import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useLocalization = () => {
    const { t, i18n } = useTranslation();

    const changeLanguage = useCallback((language: string) => {
        i18n.changeLanguage(language);
        // Persist the user's language choice for the next session.
        localStorage.setItem('preferred_language', language);
    }, [i18n]);

    const getCurrentLanguage = useCallback(() => {
        return i18n.language;
    }, [i18n.language]);

    const getSupportedLanguages = useCallback(() => {
        return [
            { code: 'en', name: 'English', flag: '🇬🇧' },
            { code: 'vi', name: 'Tiếng Việt', flag: '🇻🇳' }
        ];
    }, []);

    const initializeLanguage = useCallback(() => {
        const savedLanguage = localStorage.getItem('preferred_language');
        if (savedLanguage && i18n.languages.includes(savedLanguage)) {
            i18n.changeLanguage(savedLanguage);
        }
    }, [i18n]);

    return {
        t,
        changeLanguage,
        getCurrentLanguage,
        getSupportedLanguages,
        initializeLanguage,
        currentLanguage: i18n.language,
        isLanguageChanging: i18n.isInitialized
    };
};
